import { Box, Button, Grid, Typography } from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '25%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    px: 4,
};

const styleModalHeader = {
    top: 0,
    textAlign: 'center',
    position: 'sticky',
    zIndex: 15,
    py: 2,
    /* borderBottom: 'solid #0B3E83 1px', */
    backgroundColor: '#ffffff',
};

const styleModalFooter = {
    mt: 1,
    pb: 3,
};

const ActionConfirmation = ({
    title,
    message,
    okButton,
    handleClose,
    handleConfirm,
    data,
}) => {
    return (
        <Box sx={style}>
            <Grid container sx={styleModalHeader}>
                <Typography variant="h5">{title}</Typography>
            </Grid>
            <Grid container sx={{ mt: 4, ml: 1 }}>
                <Grid itme xs={12}>
                    <Typography variant="body1">{message}</Typography>
                </Grid>
            </Grid>
            <Grid container spacing={5} sx={styleModalFooter}>
                <Grid item xs={12} md={6}>
                    <Button fullWidth variant="outlined" onClick={handleClose}>
                        Cerrar
                    </Button>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => handleConfirm(data)}
                        color="error"
                    >
                        {okButton}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ActionConfirmation;
